export function arrayBufferToBase64(buffer) {
    var binary = String.fromCharCode.apply(null, new Uint8Array(buffer));
    return btoa(binary);
}

function getSubtle() {
    if (typeof window === 'undefined') return null;
    var c = window.crypto || window.msCrypto || null; // msCrypto: çok eski IE için
    if (!c) return null;
    return c.subtle || c.webkitSubtle || null;        // Safari fallback
}


export async function generateRsaKeys() {
    var subtle = getSubtle();

    // HTTPS + WebCrypto varsa bunu kullan
    if (typeof window !== 'undefined' && window.isSecureContext && subtle) {
        var keyPair = await subtle.generateKey(
            {
                name: 'RSA-OAEP',
                modulusLength: 2048,
                publicExponent: new Uint8Array([1, 0, 1]),
                hash: 'SHA-256'
            },
            true,
            ['encrypt', 'decrypt']
        );

        var spki  = await subtle.exportKey('spki',  keyPair.publicKey);
        var pkcs8 = await subtle.exportKey('pkcs8', keyPair.privateKey);

        return {
            publicKeyBase64: arrayBufferToBase64(spki),
            privateKeyBase64: arrayBufferToBase64(pkcs8)
        };
    }

    // Fallback: node-forge (HTTP'te çalışır; yavaştır)
    var mod = await import('node-forge');
    var forge = mod.default || mod;

    var pair = forge.pki.rsa.generateKeyPair({ bits: 2048, e: 0x10001 });

    // SPKI public
    var pubAsn1 = forge.pki.publicKeyToAsn1(pair.publicKey);
    var pubDer  = forge.asn1.toDer(pubAsn1).getBytes();

    // PKCS#8 private
    var prvAsn1 = forge.pki.privateKeyToAsn1(pair.privateKey);
    var prvInfo = forge.pki.wrapRsaPrivateKey(prvAsn1);
    var prvDer  = forge.asn1.toDer(prvInfo).getBytes();

    return {
        publicKeyBase64:  btoa(pubDer),
        privateKeyBase64: btoa(prvDer)
    };
}
